<template>
  <div>
    <sc-link
      v-if="field && field.value && field.value.text"
      :field="field"
      class="c-cta--primary"
    />
    <div v-if="field && field.value && field.value.title" class="download-description">
      {{ field.value.title }}
    </div>
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'CIS-ResourceDownloadFile',
  props: {
    field: {
      type: Object
    }
  },
  components: {
    ScLink: Link
  }
};
</script>
<style lang="scss" scoped>
.download-description {
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: 400;
  margin: -1rem auto 2rem;
  @include tablet-down {
    text-align: center;
  }
}
</style>
